var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-sans",attrs:{"id":"app"}},[_c('main-header',{attrs:{"isGerman":_vm.isGerman},on:{"toggleLanguage":function($event){return _vm.toggleLanguage()}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }